
'use strict';

/* * taboola factory
 * 1) Inject taboola Scripts and load the first taboola widget on pageLoad
 * 2) Dynamically create taboola container IDs and load taboola widget when url is updated onScroll
 * */

angular.module('storyApp').factory('taboola',  function() {

    var doc = document;

    var taboola = {

        storyUrl: location.href,

        taboolaJS: 'http://cdn.taboola.com/libtrc/foxsports/loader.js',

        taboola: undefined,

        isMobile: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

        setTaboola: function(v) {
            var that = this;
            that.taboola = v;
        },

        isTaboola: function() {
            return this.taboola
        },

        taboolaLoadOnScroll: [],

        taboolaOnLoadBelowContent1st: function() {

            window._taboola = window._taboola || [];
            _taboola.push(
                {
                    article:'auto',
                    url: taboola.storyUrl
                },
                {
                    mode: 'thumbnails-b',
                    container: 'taboola_below_article_1',
                    placement: 'Below Article Thumbnails 3x2',
                    target_type: 'mix'
                },
                {
                    flush: true
                }
            );
        },

        taboolaOnLoadRightRail1st: function() {

            window._taboola = window._taboola || [];
            _taboola.push(
                {
                    article:'auto',
                    url: taboola.storyUrl
                },
                {
                    mode: 'thumbnails-rr',
                    container: 'taboola_right_rail_1',
                    placement: 'Right Rail Thumbnails 1x2',
                    target_type: 'mix'
                },
                {
                    flush: true
                }
            );
        },

        getTaboolaJS: function(url){

            // Create a new script and setup the basics.
            var s = document.createElement("script");
            var scriptTag = document.getElementsByTagName('script')[0];

            s.async = true;
            s.src = url;

            // Handle the case where an optional callback was passed in.

            s.onload = function(){

                //callback();

                this.setTaboola(true);
                this.taboolaOnLoadBelowContent1st();
                this.taboolaOnLoadRightRail1st();

                // Clear it out to avoid getting called more than once or any memory leaks.
                s.onload = s.onreadystatechange = undefined;

            }.bind(this);

            s.onreadystatechange = function() {
                if ("loaded" === s.readyState || "complete" === s.readyState) {
                    s.onload();
                }
            };

            // Attach the script tag to the page (before the first script).
            scriptTag.parentNode.insertBefore(s, scriptTag);

        },

        createTaboolaBelowConentOnScroll: function(id, elm) {
            var selector = doc.querySelector(elm);
            //check if Taboola on the bottom of that story is not rendered
            //since we only want to render bottom Taboola on that story once
            if (!this.taboolaLoadOnScroll[id] && selector !== null) {

                selector.setAttribute('id', id);

                _taboola.push({article:'auto',url: location.href},{
                    mode: 'thumbnails-a',
                    container: id,
                    placement: 'Below Article Thumbnails 3x1 Scroll',
                    target_type: 'mix'
                },{flush: true});

                this.taboolaLoadOnScroll[id] = true;
            }
        },

        createTaboolaRightRailOnScroll: function(id, elm) {
            var selector = doc.querySelector(elm);
            //check if Taboola on the right rail on that story is not rendered
            //since we only want to render right rail Taboola on that story once
            if (!this.taboolaLoadOnScroll[id] && selector !== null) {

                selector.setAttribute('id', id);

                _taboola.push({article:'auto',url: location.href},{
                    mode: 'thumbnails-rr',
                    container: id,
                    placement: 'Right Rail Thumbnails 1x2',
                    target_type: 'mix'
                },{flush: true});

                this.taboolaLoadOnScroll[id] = true;
            }
        },

        onChange: function(storyInt) {

            //performance.mark('taboola-create-onscroll');

            var isTaboola = this.isTaboola();
            var belowContentE = "#story-" + storyInt + " .taboola_below_content";
            var belowContentId = 'taboola_below_article_' + storyInt;
            var rightrailE = "#story-" + storyInt + " .taboola_right_rail";
            var rightrailId = 'taboola_right_rail_' + storyInt;

            //since the 2nd, 3rd and 4th stories are injected in the dom onScroll,
            //we need to dynamically create taboola id onScrollDown
            //check if the taboola is not created, then create one
            if (isTaboola) {
                this.createTaboolaBelowConentOnScroll(belowContentId, belowContentE);
                this.createTaboolaRightRailOnScroll(rightrailId, rightrailE);
            }

        },

        init: function() {

            // performance.mark('taboola-create-onload');
            //only initialize if it is not on mobile
            //in mobile, we don't include taboola, we will promote mobile apps
            if( !this.isMobile ) {
                //asynchronously load taboola JS file and load the first taboola widget
                this.getTaboolaJS(this.taboolaJS);
            }

        }

    };

    taboola.init();

    return taboola;

});



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/taboola.js